// const runEnvironment = 'production'; // 线上环境
// // const runEnvironment = 'development'; // 预发环境
// let object ={};
// if (runEnvironment == 'production') {
// 	object = {
// 		houseUrl: 'https://api.m.jd.com/api?appid=house-data', // 上线接口地址
// 		esfrUrl: 'http://esfr.m.jd.com/', // JDReact二手房线上访问地址
// 		housePriceUrl: '//fangjia.m.jd.com/detailsx?primarykey=', // 查房价单品页上线访问网址
// 	}
// } else {
// 	object = {
// 		houseUrl: 'https://beta-api.m.jd.com/api?appid=house-data', // 预发接口地址
// 		esfrUrl: 'http://esfryf.m.jd.com/', // JDReact二手房预发访问地址
// 		housePriceUrl: '//fangjiayufa.m.jd.com/detailsx?primarykey=' // 查房价单品页预发访问网址
// 	}
// }
const object = {
	// houseUrl: 'https://beta-api.m.jd.com/api?appid=house-data',
	houseUrl: 'https://api.m.jd.com/api?appid=house-data', // 上线接口地址
	housePriceUrl: 'https://fangjia.m.jd.com/detailsx?primarykey=', // 查房价上线访问网址
	esfUrl: 'https://esf.m.jd.com/', // Vue二手房项目上线访问地址,
	esfrUrl: 'https://esfr.m.jd.com/', // JDReact二手房线上访问地址
	// housePriceUrl: 'https://fangjiayufa.m.jd.com/detailsx?primarykey=', // 查房价预发访问网址
	// esfUrl: 'https://esfyf.m.jd.com/', // Vue二手房项目预发访问地址,
	// esfrUrl: 'https://esfryf.m.jd.com/', // JDReact二手房预发访问地址
};
export default object
